import clsx from 'clsx';
import React from 'react';
import { FiX, FiCalendar } from 'react-icons/fi';

export interface FilterData {
  startDate: string;
}

export interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: FilterData) => void;
  className?: string;
}

export const FilterModal: React.FC<FilterModalProps> = ({
  isOpen,
  onClose,
  onApply,
  className,
}) => {
  const [startDate, setStartDate] = React.useState('');

  if (!isOpen) return null;

  const handleClear = () => {
    setStartDate('');
  };

  const handleApply = () => {
    onApply({
      startDate,
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className={clsx('bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4', className)}>
        {/* Header */}
        <div className="border-b border-neutral-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-neutral-800">Filtros</h2>
            <button
              type="button"
              onClick={onClose}
              className="p-2 text-neutral-400 hover:text-neutral-600 transition-colors"
              aria-label="Fechar"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          {/* Date */}
          <div>
            <label className="block text-xs font-medium text-neutral-700 mb-1">Data</label>
            <div className="relative">
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                placeholder="Inserir"
                className="w-full px-3 py-2 pr-9 border border-neutral-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
              <FiCalendar className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-purple-600 pointer-events-none" />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-neutral-200 px-6 py-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={handleClear}
            className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-lg hover:bg-neutral-50 transition-colors font-medium text-sm"
          >
            Limpar filtros
          </button>
          <button
            type="button"
            onClick={handleApply}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors font-medium text-sm"
          >
            Aplicar filtros
          </button>
        </div>
      </div>
    </div>
  );
};
